function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';

var CPClaimExtension = function CPClaimExtension(_claim) {
    _classCallCheck(this, CPClaimExtension);

    Object.defineProperty(this, '_claim', {
        enumerable: false,
        value: _claim
    });

    var commercialProperty = this._claim.lobs.commercialProperty;

    this.incidentReport = commercialProperty && _.isBoolean(commercialProperty.incidentReport) ? commercialProperty.incidentReport : false;
    this.dateOfNotice = commercialProperty && commercialProperty.dateOfNotice ? commercialProperty.dateOfNotice : null;
    this.fixedPropertyIncidents = commercialProperty && commercialProperty.fixedPropertyIncidents ? commercialProperty.fixedPropertyIncidents : null;
};

export default CPClaimExtension;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/cp/models/CPClaimExtension.js
// module id = 1540
// module chunks = 0